import { QDialog as e } from "quasar";
import { Fragment as t, computed as n, createBlock as r, createElementBlock as i, createElementVNode as a, createVNode as o, defineComponent as s, onUnmounted as c, openBlock as l, ref as u, unref as d, withCtx as f } from "vue";
import { RichTextEditor as p } from "@editor/ui-richtext";
import { getI18n as m, useWordCountStore as h } from "@editor/ui-utils";
import { EntitiesList as g } from "@modules/entity-picker-editor-ui";
import { TableOfContentsInput as _ } from "@modules/news-article-editor-ui";
//#region src/blocks/text-content-block.vue?vue&type=script&setup=true&lang.ts
var v = { class: "q-mt-md q-mb-sm" }, y = {
	messages: {
		en: { contentBlocks: { text: "Text" } },
		de: { contentBlocks: { text: "Text" } }
	},
	routes: [],
	contentBlocks: [{
		type: "TEXT",
		label: "contentBlocks.text",
		icon: "align-left",
		component: /* @__PURE__ */ s({
			__name: "text-content-block",
			props: {
				block: { default: () => ({
					content: "<p></p>",
					type: "TEXT"
				}) },
				locked: {
					type: Boolean,
					default: !1
				},
				brand: {}
			},
			emits: ["update:block", "wordCharUpdate"],
			setup(s, { emit: y }) {
				let b = s, x = y, S = (e) => m().t(e), C = u(void 0), w = n({
					get: () => b.block,
					set: (e) => x("update:block", e)
				}), T = u(!1), E = u(0), D = u(0), O = u(0), k = h(), A = u(""), j = n(() => ({ wordCharCount: {
					words: D.value,
					characters: O.value
				} })), M = (e) => {
					A.value = e, T.value = !T.value;
				};
				function N(e) {
					if (!C.value) {
						console.warn("Editor reference is not set.");
						return;
					}
					A.value === "" ? C.value?.insertLinkAtMousePosition(e.content, e.linkHref) : C.value?.addLinkToExistingText(e.linkHref);
				}
				let P = (e) => {
					x("wordCharUpdate", {
						words: e.words - D.value,
						characters: e.characters - O.value
					}), D.value = e.words, O.value = e.characters;
				};
				return k.onMount(j), c(() => {
					k.onUnmount(j);
				}), (n, c) => (l(), i(t, null, [
					o(d(_), {
						modelValue: w.value.tableOfContentsText,
						"onUpdate:modelValue": c[0] ||= (e) => w.value.tableOfContentsText = e,
						disabled: s.locked,
						readonly: s.locked
					}, null, 8, [
						"modelValue",
						"disabled",
						"readonly"
					]),
					(l(), r(d(p), {
						key: E.value,
						ref_key: "editor",
						ref: C,
						modelValue: w.value.content,
						"onUpdate:modelValue": c[1] ||= (e) => w.value.content = e,
						"data-qa-article-content-text-block-textarea": "",
						style: { "white-space": "break-spaces" },
						disabled: s.locked,
						readonly: s.locked,
						"link-entities": !0,
						"ai-assist": "",
						"ai-assist-actions": ["basic", "correct"],
						"ai-assist-label": S("articles.content"),
						onWordCharUpdate: P,
						onToggleLinkEntitiesDialog: M
					}, null, 8, [
						"modelValue",
						"disabled",
						"readonly",
						"ai-assist-label"
					])),
					a("div", v, [o(d(e), {
						modelValue: T.value,
						"onUpdate:modelValue": c[3] ||= (e) => T.value = e,
						"data-qa-list-tags-dialog": "",
						"full-width": "",
						"full-height": "",
						"allow-focus-outside": ""
					}, {
						default: f(() => [o(d(g), {
							"show-dialog": T.value,
							brand: s.brand,
							"highlighted-text": A.value,
							"article-tab": "",
							"tag-tab": "",
							"hub-page-tab": "",
							onClose: c[2] ||= (e) => T.value = !1,
							"onClick:entity": N
						}, null, 8, [
							"show-dialog",
							"brand",
							"highlighted-text"
						])]),
						_: 1
					}, 8, ["modelValue"])])
				], 64));
			}
		}),
		defaultValue: { content: "<p></p>" }
	}]
};
//#endregion
export { y as textContentBlockModule };

//# sourceMappingURL=index.es.js.map